import React, { useState, useEffect, useRef } from 'react';
import { checkMenu } from '../Utils/Common';
import DefaultLayout from '../component/DefaultLayout';
import Footer from '../component/Footer';
import Api from '../config/Api';
import { Link as LinkRouter } from 'react-router-dom';
import { AiOutlinePlus, AiFillEdit, AiFillDelete } from 'react-icons/ai'
// import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Card from 'react-bootstrap/Card';
import { AiOutlineRollback } from "react-icons/ai";
import { useHistory, useParams } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import { FiSearch } from "react-icons/fi";
import moment from 'moment'
import DatePicker from "react-datepicker";
import RenderCustomHeader from '../component/RenderCustomHeader';
import "react-datepicker/dist/react-datepicker.css";
// import InputMask from 'react-input-mask';
import { NumericFormat } from 'react-number-format';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
	ClassicEditor,
	Bold,
	Essentials,
	Heading,
	Indent,
	IndentBlock,
	Italic,
	Link,
	List,
	MediaEmbed,
	Paragraph,
	Table,
	Undo
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import dayjs from "dayjs";
import 'bootstrap/dist/css/bootstrap.min.css';

function Addproject() {
	const history = useHistory();
	const [categorys, setCategorys] = useState([]);
	const [subCategorys, setSubCategorys] = useState([]);
	const [details, setDetails] = useState({});
	const [error, setError] = useState(null);
	const [errorForm, setErrorForm] = useState([]);
	const [validated, setValidated] = useState(false);
	const [defaultSelectedCategory, setDefaultSelectedCategory] = useState({});
	const [defaultSelectedSubCategory, setDefaultSelectedSubCategory] = useState({});

	const today = new Date();
	
	const [startDate, setStartDate] = useState(new Date());
	
	const [formData, setFormData] = useState({
		projectName: '',
		clientName: '',
		country: '',
		city: '',
		district: '',
		address: '',
		startDate: '',
		endDate: '',
		duration: '',
		approxValue: '',
		categoryId: '',
		status: '',
		totalBudget: 0,
		totalProgress: 0,
		details: '',
		descriptions: '',
	});

	const editorRef = useRef();

	useEffect(() => {
		getCategorys(defaultSelectedCategory)
		getSubCategorys(defaultSelectedCategory, defaultSelectedSubCategory)
	}, []);


	const getCategorys = (selectedId) => {
		var categoryList = []
		Api().get(`categories/all`)
		.then((response) => response)
		.then((respCat) => {
			console.log(respCat)
			if( respCat?.status === 200 )
			{
				// const mainCat = respCat?.data?.docs.filter(item => item.parentId === null)
				for( let i=0; i < respCat.data.length; i++)
				{
					var selectedParent = false
					if( respCat.data[i]._id === selectedId )
					{
							selectedParent = true;
					}
					respCat.data[i].selected = selectedParent
				}
				console.log(respCat.data);
				setCategorys(respCat.data);
			}
		})
		.catch((err) => {
		});
	}

	const getSubCategorys = (parentId, selectedId) => {
		Api().get(`categories?page=1&limit=10&filter=${parentId}&fields=parentId`)
		.then((response) => response)
		.then((resSubCategories) => {
			console.log(resSubCategories)
			if( resSubCategories?.status === 200 )
			{
				for( let i=0; i < resSubCategories.data.totalDocs; i++)
				{
					var selected = false
					if( resSubCategories.data.docs[i]._id === selectedId )
					{
							resSubCategories.data.docs[i].selected = true;
					}
				}
				
				setSubCategorys(resSubCategories.data.docs);
			}
		})
		.catch((err) => {
		});
	}

	const onChangeEditor = (e) => {
		setFormData({...formData, ['details']: e})
	}

	const handleChangeStartDate = (e) => {
		// console.log(e)
		const date = new Date(e);
		const formatted = dayjs(date).format("DD/MM/YYYY");
		// console.log(formatted)
		setFormData({...formData, startDate: formatted})
	}

	const handleChangeEndDate = (e) => {
		// console.log(e)
		const date = new Date(e);

		const formatted = dayjs(date).format("DD/MM/YYYY");
		// console.log(formatted)
		setFormData({...formData, endDate: formatted})
	}

	const handleChange = (e) => {
		// console.log(e)
		const key = e.target.name;
		const value = e.target.value;
		setFormData({...formData, [key]: value})
	}

	const handleChangeSelectCategory = (e) => {
		const key = e.target.name;
		const value = e.target.value;
		// console.log(value)
		setDefaultSelectedCategory(value)
		setDefaultSelectedSubCategory(null)
		getCategorys(value);
		getSubCategorys(value, defaultSelectedSubCategory);
		setFormData({...formData, [key]: value})
	}

	const handleChangeSelectSubCategory = (e) => {
		const key = e.target.name;
		const value = e.target.value;
		setDefaultSelectedSubCategory(value)
		setFormData({...formData, [key]: value})
	}

	const parseDate = (dateString) => {
		const [day, month, year] = dateString.split('/');
		return new Date(year, month - 1, day);
	}

	const currencyToNumber = (value) => {
		return Number(value.replace(/[^\d]/g, ''));
	}
	
	const handleSubmit = (req) => {
		req.preventDefault();
		const form = req.currentTarget;
		if (form.checkValidity() === false) {
			req.preventDefault();
			req.stopPropagation();
			return;
		}

		setValidated(true);
		var data = new FormData(form);
		let formObject = Object.fromEntries(data.entries());
		if(formObject.subCategory === undefined || formObject.subCategory === null || formObject.subCategory === "")
		{
			formObject.categoryId = formObject.category
		}
		else
		{
			formObject.categoryId = formObject.subCategory
		}
		formObject.details = formData.details;
		// console.log(today)
		const startDate = new Date(formObject.startDate !== null ? parseDate(formObject.startDate) : today);
		const endDate = new Date(formObject.endDate !== null ? parseDate(formObject.endDate) : today);
		const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
		const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");
		// console.log(startDate);
		// console.log(formattedStartDate);
		// console.log(formObject);
		formObject.startDate = formattedStartDate
		formObject.endDate = formattedEndDate
		formObject.totalBudget = currencyToNumber(formObject.totalBudget)
		formObject.totalProgress = parseFloat(formObject.totalProgress)
		
		Api().post(`projects`, formObject)
		.then((response) => response)
		.then((data) => {
			if( data.status === 200 || data.status === 201){
				history.push('/projects');
			}
		})
		.catch((err) => {
		});
	};
		
	return (
		<>
			<div style={{ display: 'flex', height: '100%', direction: 'ltr' }}>
				<DefaultLayout />
				{/* <div className={ getStyles().collapsed === true ? 'content-wrapper collapsed' : 'content-wrapper' }> */}
				<main>
					<div className="content-header">
						<Container fluid>
							<Row className="">
								<Col sm={4}>
									<h1 className="m-0">Add Project</h1>
								</Col>
								<Col sm={2}>
									{ checkMenu('projects') &&
										<LinkRouter to="/projects"><Button variant="outline-primary" className="btn-upload"><AiOutlineRollback /> Back</Button></LinkRouter>
									}
								</Col>
								<Col sm={3}>
								</Col>
								<Col sm={3}>
									<div className="date-time float-sm-right">
											{ moment().format('dddd, DD MMMM YYYY') }
									</div>
								</Col>
							</Row>
						</Container>
					</div>
							
					<div className="content">
						<Container fluid>
							<Row>
								<Col lg={12}>
									<Card className="content-list">
										<Card.Body>
											<Col md="12">
												<Form noValidate validated={validated} onSubmit={handleSubmit}>
													<Row className="mb-3">
														<Form.Group as={Col} md="4" controlId="validationCustom08">
															<Form.Label>Services</Form.Label>
															<Form.Control
																required
																as="select"
																name="category"
																defaultValue={defaultSelectedCategory}
																// value={defaultSelectedCategory}
																onChange={handleChangeSelectCategory}
															>
																<option value="">Select Service</option>
																{
																	categorys.map((item, i) => (
																		<option key={i} value={item._id} selected={item.selected}>{item.name}</option>
																	))
																}
															</Form.Control>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom08">
															<Form.Label>Sub Services</Form.Label>
															<Form.Control
																// required
																as="select"
																name="subCategory"
																defaultValue={defaultSelectedSubCategory}
																// value={defaultSelectedCategory}
																onChange={handleChangeSelectSubCategory}
															>
																<option value="">Select Sub Service</option>
																{
																	subCategorys.map((item, i) => (
																		<option key={i} value={item._id} selected={item.selected}>{item.name}</option>
																	))
																}
															</Form.Control>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Project Name</Form.Label>
															<Form.Control
																required
																type="text"
																name="projectName"
																defaultValue={formData.projectName || ''}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Client Name</Form.Label>
															<Form.Control
																required
																type="text"
																name="clientName"
																defaultValue={formData.clientName || ''}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom03">
															<Form.Label>Address</Form.Label>
															<Form.Control
																required
																as="textarea"
																name="address"
																defaultValue={formData.address || ''}
																onChange={handleChange}
															/>
														</Form.Group>	
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Kelurahan</Form.Label>
															<Form.Control
																// required
																type="text"
																name="district"
																defaultValue={formData.district || ''}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Kota</Form.Label>
															<Form.Control
																required
																type="text"
																name="city"
																defaultValue={formData.city || ''}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Negara</Form.Label>
															<Form.Control
																required
																type="text"
																name="country"
																defaultValue={formData.country || ''}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom03">
															<Form.Label>Approx Value</Form.Label>
															<Form.Control
																// required
																as="textarea"
																name="approxValue"
																defaultValue={formData.approxValue || ''}
																onChange={handleChange}
															/>
														</Form.Group>	
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Durasi</Form.Label>
															<Form.Control
																// required
																type="text"
																name="duration"
																defaultValue={formData.duration || ''}
																onChange={handleChange}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Total Budget</Form.Label>
															<NumericFormat
																value={formData.totalBudget || ''}
																onValueChange={(e) => {
																	setFormData({...formData, totalBudget: e.value})
																}}
																thousandSeparator={true}
																thousandSeparator={true}
																prefix={'IDR '}
																decimalScale={0}
																fixedDecimalScale={false}
																allowNegative={false}
																className="currency-input form-control"
																placeholder="Enter amount"
																name="totalBudget"
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Tanggal Mulai</Form.Label>
															<DatePicker 
																name="startDate" 
																format="DD/MM/YYYY" 
																value={formData.startDate || today} 
																onChange={handleChangeStartDate} 
																renderCustomHeader={(props) => (
																	<RenderCustomHeader {...props} />
																)}
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Tanggal Berakhir</Form.Label>
															<DatePicker 
																name="endDate" 
																format="DD/MM/YYYY" 
																value={formData.endDate || today} 
																onChange={handleChangeEndDate} 
																renderCustomHeader={(props) => (
																	<RenderCustomHeader {...props} 
																		startYear={1980}
  																	endYear={20}
																	/>
																)}
															/>
															
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom02">
															<Form.Label>Total Progress</Form.Label>
															<NumericFormat
																value={formData.totalProgress || ''}
																onValueChange={(e) => {
																	setFormData({...formData, totalProgress: e.value})
																}}
																thousandSeparator={true}
																thousandSeparator={true}
																suffix={' %'}
																decimalScale={0}
																fixedDecimalScale={false}
																allowNegative={false}
																className="currency-input form-control"
																placeholder="Enter Progress in Percentage"
																name="totalProgress"
															/>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="4" controlId="validationCustom08">
															<Form.Label>Status</Form.Label>
															<Form.Control
																required
																as="select"
																name="status"
																onChange={handleChange}
															>
																<option value="">Select Status</option>
																<option value="Planning" selected={formData.status === "Planning" ? true : false}>Planning</option>
																<option value="Ongoing" selected={formData.status === "Ongoing" ? true : false}>Ongoing</option>
																<option value="Completed" selected={formData.status === "Completed" ? true : false}>Completed</option>
																<option value="Hold" selected={formData.status === "Hold" ? true : false}>Hold</option>
																<option value="Cancelled" selected={formData.status === "Cancelled" ? true : false}>Cancelled</option>
															</Form.Control>
														</Form.Group>
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom03">
															<Form.Label>Descriptions</Form.Label>
															<Form.Control
																// required
																as="textarea"
																rows={5}
																name="descriptions"
																defaultValue={formData.descriptions || ''}
																onChange={handleChange}
															/>
														</Form.Group>	
													</Row>
													<Row className="mb-3">
														<Form.Group as={Col} md="12" controlId="validationCustom03">
															<Form.Label>Details</Form.Label>
															<CKEditor
																editor={ ClassicEditor }
																config={ {
																	toolbar: [
																		'undo', 'redo', '|',
																		'heading', '|', 'bold', 'italic', '|',
																		'link', 'insertTable', 'mediaEmbed', '|',
																		'bulletedList', 'numberedList', 'indent', 'outdent'
																	],
																	licenseKey: 'GPL',
																	plugins: [
																		Bold,
																		Essentials,
																		Heading,
																		Indent,
																		IndentBlock,
																		Italic,
																		Link,
																		List,
																		MediaEmbed,
																		Paragraph,
																		Table,
																		Undo
																	],
																	root: {
																		initialData: formData.details || '',
																		placeholder: '',
																	},
																} }
																onReady={ (editor) => {
																	editorRef.current = editor;
																} }
																data={ formData.details || '' }
																onChange={ () => {
																	onChangeEditor( editorRef.current?.getData() );
																} }
															/>
														</Form.Group>	
                            <input type='hidden' defaultValue={formData.details} name="details" />
													</Row>
													{error && 
														<Alert variant="danger">
															{error}
														</Alert>
													}
													<Button type="submit">Save</Button>
												</Form>
											</Col>
										</Card.Body>
									</Card>
								</Col>
							</Row>
						</Container>
					</div>
				</main>
			</div>
			<Footer />
		</>
	)
}
export default Addproject